export default __webpack_public_path__ + "static/media/news-hero.d2628376.png";